<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <v-tabs color="transparent">
        <v-tab
          v-for="item in accountSettings"
          :to="{name: item.routeName}"
          :key="item.name">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider/>
      <v-flex>
        <router-view/>
      </v-flex>
    </v-card>
  </app-layout>
</template>

<script>
export default {
  name: 'EmployeeSettings',
  data () {
    return {
      accountSettings: [
        { name: this.$t('personal'), routeName: 'employeeSettings.personal' },
        { name: this.$t('timesheets'), routeName: 'employeeSettings.schema' },
        { name: this.$t('holidays'), routeName: 'employeeSettings.holidays' },
        { name: this.$t('userify'), routeName: 'employeeSettings.userify' },
        { name: this.$t('promotion'), routeName: 'employeeSettings.role' },
        { name: this.$t('delete'), routeName: 'employeeSettings.delete' }
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        delete: 'Delete employee',
        heading: 'Employee settings',
        personal: 'Personal',
        promotion: 'Promote',
        salaryGroup: 'Salarygroup',
        timesheets: 'Timesheets',
        userify: 'Userify',
        holidays: 'Holidays'
      },
      tr: {
        delete: 'Çalışanı sil',
        heading: 'Çalışan ayarları',
        personal: 'Kişisel',
        promotion: 'Terfi',
        salaryGroup: 'Gelir grubu',
        timesheets: 'Zaman çizelgesi',
        userify: 'Kullanıcı hesabı oluşturun',
        holidays: 'İzinler'
      },
      de: {
        delete: 'Entfernen',
        heading: 'Mitarbeitereinstellungen',
        personal: 'Persönliche',
        promotion: 'Beförderung',
        salaryGroup: 'Gehaltsgruppe',
        timesheets: 'Arbeitszeiten',
        userify: 'Benutzerkonto',
        holidays: 'Urlaub'
      },
      ru: {
        delete: 'Удалить сотрудника',
        heading: 'Настройки сотрудника',
        personal: 'Личное',
        promotion: 'Повысить',
        salaryGroup: 'Зарплатная группа',
        timesheets: 'Табель',
        userify: 'Учетная запись',
        holidays: 'Отпуска'
      }
    }
  }
}
</script>
